import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';
// import { Location } from '@angular/common';
// import { UserRolesEnum as UserRoles } from '../enums/user-roles.enum';

export const SystemAdminGuard: CanActivateFn = (_, __) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const role = authService.getProperty('isAdmin');
  if (role) {
    return true;
  }

  router.navigate(['dashboard']);
  return false;
};

export const IsUserAllowed: CanActivateFn = (route, _) => {
  const authService = inject(AuthService);
  const permissionService = inject(PermissionService);
  // const location = inject(Location);

  if (authService.getProperty('isAdmin')) {
    return true;
  }

  const permissionData: any = permissionService.getScreenPermissionsData();
  if (!permissionData) return false;
  const has = permissionData[route.data['screen']];

  if (has) return true;

  // location.back();
  return false;
};

export const IsNotSystemAdminGuard: CanActivateFn = (_, __) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const role = authService.isAdmin();
  if (!role) {
    return true;
  }

  router.navigate(['client-management']);
  return false;
};

// export const CollectorGuard: CanActivateFn = (_, __) => {
//   const router = inject(Router);
//   const authService = inject(AuthService);
//   const role = authService.getRole;

//   if (role && role.toLowerCase() == UserRoles.USER_COLLECTOR) {
//     return true;
//   } else if (role) {
//     router.navigate([role.toLowerCase(), 'dashboard']);
//   } else {
//     // authService.login();
//   }

//   return false;
// };

// export const ManagerGuard: CanActivateFn = (_, __) => {
//   const router = inject(Router);
//   const authService = inject(AuthService);
//   const role = authService.getRole;

//   if (role && role.toLowerCase() == UserRoles.OPERATION_MANAGER) {
//     return true;
//   } else if (role) {
//     router.navigate([role.toLowerCase(), 'dashboard']);
//   } else {
//     // authService.login();
//   }

//   return false;
// };
